import { Capacitor } from '@capacitor/core'

export function isIOSBrowser(): boolean {
  return /iPhone|iPad|iPod/.test(navigator.userAgent)
}

export function isAndroidBrowser(): boolean {
  return /Android/.test(navigator.userAgent)
}

export function isMobileBrowser(): boolean {
  return !Capacitor.isNativePlatform() && (isIOSBrowser() || isAndroidBrowser())
}
